"use client";

import React from "react";
import { Send, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider } from "@/integrations/forms/FormProvider";
const formFields = [{
  id: "CONTACT NAME",
  label: "Contact Name",
  type: "text",
  placeholder: "Parent or Player Name",
  colSpan: 1
}, {
  id: "email",
  label: "Email Address",
  type: "email",
  placeholder: "recruitment@example.com",
  colSpan: 1
}, {
  id: "phone",
  label: "Phone Number",
  type: "tel",
  placeholder: "(555) 000-0000",
  colSpan: 1
}, {
  id: "location",
  label: "Location",
  type: "text",
  placeholder: "City, State/Prov",
  colSpan: 1
}, {
  id: "playerName",
  label: "Player Name",
  type: "text",
  placeholder: "Full Name",
  colSpan: 1
}, {
  id: "birthYear",
  label: "Birth Year",
  type: "text",
  placeholder: "YYYY",
  colSpan: 1
}, {
  id: "height",
  label: "Height",
  type: "text",
  placeholder: "e.g., 6'1\"",
  colSpan: 1
}, {
  id: "weight",
  label: "Weight",
  type: "text",
  placeholder: "e.g., 185 lbs",
  colSpan: 1
}, {
  id: "position",
  label: "Position",
  type: "text",
  placeholder: "F / D / G",
  colSpan: 1
}, {
  id: "shoots",
  label: "Shoots",
  type: "text",
  placeholder: "Left / Right",
  colSpan: 1
}, {
  id: "currentTeam",
  label: "Current Team & League",
  type: "text",
  placeholder: "Team Name (League)",
  colSpan: 2
}, {
  id: "previousTeams",
  label: "Previous Teams",
  type: "text",
  placeholder: "List recent teams",
  colSpan: 2
}, {
  id: "gradYear",
  label: "Graduation Year",
  type: "text",
  placeholder: "YYYY",
  colSpan: 1
}, {
  id: "goals",
  label: "Hockey Goals",
  type: "text",
  placeholder: "Junior, College, Pro",
  colSpan: 1
}, {
  id: "links",
  label: "Elite Prospects / Video Links",
  type: "url",
  placeholder: "https://www.eliteprospects.com/player/...",
  colSpan: 2
}];
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return;
}